import { useLocalization } from '../../../../context/Localization/localization';
import { useKioskState } from '../../../../context/Kiosk/kiosk';

export const MachineId = () => {
    const Localization = useLocalization();
    const { machineId, kioskType } = useKioskState();

    return <p>{kioskType === 'express' && machineId && Localization.formatString('{0} {1}', Localization.MachineId, machineId)}</p>;
};
